export const BirthdayCards = {
    pathPrefix: "birthday",
    cards: [
        { file: "bcard-202009-1.jpg" },
        { file: "bcard-202009-2.jpg" },
        { file: "bcard-202009-3.jpg" },
        { file: "bcard-202009-4.jpg" },
        { file: "bcard-202009-5.jpg" },
        { file: "bcard-202009-6.jpg" },
        { file: "bcard-202009-7.jpg" },
        { file: "bcard-202009-8.png" },
        { file: "grace.png" },
        
    ]
}